"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "poggio-torriana": {
    "d3588d2f": [{
      "hkey": "33183828",
      "slug": "poggio-torriana",
      "name": "Poggio Torriana",
      "primary": true,
      "skipSearch": false
    }],
    "bruciatini": [{
      "hkey": "33183828",
      "slug": "poggio-torriana",
      "name": "Poggio Torriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e248f02e": [{
      "hkey": "33183828",
      "slug": "poggio-torriana",
      "name": "Poggio Torriana",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo": [{
      "hkey": "33183828",
      "slug": "poggio-torriana",
      "name": "Poggio Torriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed9d05ae": [{
      "hkey": "4c261709",
      "slug": "torriana-sodo-comune",
      "name": "Torriana-Sodo Comune",
      "primary": true,
      "skipSearch": false
    }],
    "sodo-comune": [{
      "hkey": "4c261709",
      "slug": "torriana-sodo-comune",
      "name": "Torriana-Sodo Comune",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "poggio-torriana"
    }],
    "64e84642": [{
      "hkey": "4c261709",
      "slug": "torriana-sodo-comune",
      "name": "Torriana-Sodo Comune",
      "primary": true,
      "skipSearch": false
    }],
    "torriana": [{
      "hkey": "4c261709",
      "slug": "torriana-sodo-comune",
      "name": "Torriana-Sodo Comune",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;